var map = {
	"./AUA-1.svg": 465,
	"./AUA.svg": 722,
	"./AUB-1.svg": 8877,
	"./AUB.svg": 2486,
	"./Georgia-1.svg": 4377,
	"./Georgia.svg": 2694,
	"./Yerevan-1.svg": 8229,
	"./Yerevan.svg": 4676,
	"./agah-1.svg": 191,
	"./agah.svg": 8598,
	"./barbat-1.svg": 2790,
	"./barbat.svg": 4822,
	"./basmeh-1.svg": 9933,
	"./basmeh.svg": 3910,
	"./bookhall-1.svg": 533,
	"./bookhall.svg": 2648,
	"./chatr-1.svg": 5533,
	"./chatr.svg": 6376,
	"./didavar-1.svg": 4376,
	"./didavar.svg": 6181,
	"./earth-1.svg": 2341,
	"./earth.svg": 1799,
	"./ebnesina-1.svg": 4512,
	"./ebnesina.svg": 7783,
	"./esm-1.svg": 62,
	"./esm.svg": 3501,
	"./fatemi-1.svg": 8423,
	"./fatemi.svg": 4752,
	"./gaahbook-1.svg": 7709,
	"./gaahbook.svg": 8354,
	"./gitamehr-1.svg": 180,
	"./gitamehr.svg": 2289,
	"./heh-1.svg": 9804,
	"./heh.svg": 8042,
	"./jeyhon-1.svg": 9000,
	"./jeyhon.svg": 9450,
	"./pardis-1.svg": 8676,
	"./pardis.svg": 8739,
	"./pp-1.svg": 1474,
	"./pp.svg": 5951,
	"./radtia-1.svg": 6173,
	"./radtia.svg": 353,
	"./saneei-1.svg": 8725,
	"./saneei.svg": 5836,
	"./shahre-farhang-1.svg": 7154,
	"./shahre-farhang.svg": 1424,
	"./shahre-ketab-1.svg": 2980,
	"./shahre-ketab.svg": 9629,
	"./soorehmehr-1.svg": 3327,
	"./soorehmehr.svg": 4782,
	"./vizhe-1.svg": 4806,
	"./vizhe.svg": 4933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7607;